var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed } from "mobx";
import { sbMsgBusPredefinedTopics } from "sb-msg-bus";
/*
    Tests describing the structure of the ouput data should be written first.
    It would be better to split the tests into few suits:
    - base tests related to class and instance structure
    - business logic
    - edge cases
*/
export class HeaderRegulationRibbonMessageBlockData {
    constructor(provider) {
        this.eventsManager = provider.eventsManager;
        this.messageBus = provider.messageBusProvider;
        this.shouldHide = true;
        this.message = { key: "", messageText: "" };
        this.isExpanded = false;
        this.hasButton = false;
        this.eventsManager.addEventListener("showRegulationMessageonUserLogin", this, this.showBlock, true);
        this.eventsManager.addEventListener("hideRegulationMessageonUserLogout", this, this.hideBlock, true);
        this.messageBus && this.messageBus.subscribe(sbMsgBusPredefinedTopics.GeoTopics.SB_ShowRegulationMessageonUserLogin, this.showBlock.bind(this));
    }
    showBlock(message) {
        this.message = this.getValidatedMessage(message);
        this.shouldHide = false;
    }
    hideBlock(message) {
        if (message) {
            if (message.key === this.message.key) {
                this.shouldHide = true;
                this.message = { messageText: "", key: "" };
            }
        }
        else {
            this.shouldHide = true;
            this.message = { messageText: "", key: "" };
        }
    }
    getValidatedMessage(message) {
        let validatedMessage = {};
        if (typeof message === "string") {
            validatedMessage.key = "";
            validatedMessage.messageText = message;
        }
        else if (message) {
            validatedMessage.key = message.key || "";
            validatedMessage.messageText = message.messageText || "";
        }
        else {
            validatedMessage.key = "";
            validatedMessage.messageText = "";
        }
        return validatedMessage;
    }
    changeExpanded(e) {
        this.isExpanded = !this.isExpanded;
    }
    winResizeHandler(containerElWidth, messageElWidth) {
        this.hasButton = containerElWidth < messageElWidth;
    }
    get chooseModifier() {
        return this.isExpanded ? "read-less" : "read-more";
    }
    get chooseBtnText() {
        return this.isExpanded ? "ReadLess" : "ReadMore";
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], HeaderRegulationRibbonMessageBlockData.prototype, "shouldHide", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HeaderRegulationRibbonMessageBlockData.prototype, "message", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], HeaderRegulationRibbonMessageBlockData.prototype, "isExpanded", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], HeaderRegulationRibbonMessageBlockData.prototype, "hasButton", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HeaderRegulationRibbonMessageBlockData.prototype, "showBlock", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HeaderRegulationRibbonMessageBlockData.prototype, "hideBlock", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HeaderRegulationRibbonMessageBlockData.prototype, "changeExpanded", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", void 0)
], HeaderRegulationRibbonMessageBlockData.prototype, "winResizeHandler", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderRegulationRibbonMessageBlockData.prototype, "chooseModifier", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderRegulationRibbonMessageBlockData.prototype, "chooseBtnText", null);
//# sourceMappingURL=HeaderRegulationRibbonMessageBlockData.js.map